import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { apiClient } from '@/shared/api/client';

/**
 * Single relay entry point for all push notification deep links.
 * The parent app navigates here via:
 *   /notifications/relay?notifId={id}
 *
 * The backend resolves which screen to open and marks the notification as read.
 * Adding a new notification type requires zero frontend changes.
 */
export function NotificationRelayPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const notifId = searchParams.get('notifId');

    if (!notifId) {
      navigate('/', { replace: true });
      return;
    }

    apiClient
      .get<{ redirectUrl: string }>(`/notifications/${notifId}/relay`)
      .then(({ redirectUrl }) => {
        navigate(redirectUrl, { replace: true });
      })
      .catch((err) => {
        console.error('[NotificationRelay] Failed to resolve notification', notifId, err);
        navigate('/', { replace: true });
      });
  }, [navigate, searchParams]);

  return null;
}
